
import React, { useState } from "react";
import { fetchData } from "../../networkRequests";
import {
  Button,
  Input
} from "reactstrap";
import LoadingArrow from "../../../../images/login/spinner-min.gif";
import { getCookie, reversibleHash, setCookie } from "../../../oro-module/commonFunctions";


const loginActivities = ({ setmessage, result, options, props }) => {

  let { username, password, strokes, currentLoginType, portal, portal_scheme } = options;
  let { token, profile, success, error } = result;

  let orosession = [];

  setmessage("");
  let logintime = new Date().getTime();
  let { session_date, assigned_roles, user_display, assigned_branch, assigned_bank, assigned_bank_uid } = profile;
  orosession = { authenticated: true, token, session_date, user_code: username, user_description: user_display, assigned_roles, assigned_branch, logintime, assigned_bank, assigned_bank_uid };
  profile.logintime = logintime;
  profile.dashtime = 1000;
  profile.loggedintoday = 0;
  profile.portal = portal;
  profile.portal_scheme = portal_scheme;
  profile.icon_url = props.parentState.icon_url;
  profile.logo_url = props.parentState.logo_url;



  //eslint-disable-next-line
  history.pushState(null, '', '/dashboard1');
  props.liftGlobalState({ name: "currentPage" }, "dashboard1");

  // send logged in username + token to authorize this socket.id
  // try {
  //   socket.emit('browserlogin', { token, loginid });
  // } catch (err) {
  //   console.log({ SOCK: err })
  // }

  // Since appwrapper is already rendered, its state will not be taken from the cookie. So set it here.
  props.liftWrapperState({ name: "profile" }, profile);
  props.liftGlobalState({ name: "profile" }, profile);

  if (profile.visiting_branches && profile.visiting_branches.length > 0) {
    let { LocalVars } = props.parentState;
    LocalVars.selectedTourBranch = { label: profile.visiting_branches[0].branch_display, value: profile.visiting_branches[0].branch_uid, code: profile.visiting_branches[0].branch_code };
    props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  }
  setCookie("profile", JSON.stringify(profile), 1);
  for (var key in orosession) {
    props.liftWrapperState({ name: key }, orosession[key]);
  }
  return orosession;
}

export const serverLogin = async ({ props, setisLoggingIn, options, client_uri, setmessage, setforcereset }) => {

  let { username, password, newpass, renewpass, strokes, currentLoginType, portal, portal_scheme } = options;
  let { remoteip } = props.parentState;


  let allLoginData = {};
  allLoginData['username'] = username;
  allLoginData['password'] = reversibleHash(password);

  allLoginData['newpass'] = reversibleHash(newpass);
  allLoginData['renewpass'] = reversibleHash(renewpass);

  allLoginData['from_url'] = reversibleHash(window.location.href);
  allLoginData['authentication_method'] = currentLoginType;
  allLoginData['strokes'] = strokes;
  allLoginData['portal'] = portal;
  allLoginData['client_uri'] = reversibleHash(client_uri);
  allLoginData['portal_scheme'] = portal_scheme;
  allLoginData['loginTime'] = new Date().getTime();



  let CBSurl = `${remoteip}/loginUser`;
  let url = CBSurl;
  let method = 'post';

  let position = getCookie("position");
  if (position) {
    allLoginData['position'] = JSON.parse(position);
  }

  let result = await fetchData({ url, postData: allLoginData, method, current: { props } });
  let { token, profile, success, error } = result;

  let orosession = [];
  setisLoggingIn(false);

  if (success) {
    if (profile) {
      if (profile.force_reset_password) {
        setforcereset(true);
        setTimeout(() => {
          let elem = document.getElementById('resetnew-password');
          if (elem) {
            elem.focus();
          }
        }, 100);
      } else {

        setmessage("");
        let logintime = new Date().getTime();
        let { session_date, assigned_roles, user_display, assigned_branch, assigned_bank, assigned_bank_uid } = profile;
        orosession = { authenticated: true, token, session_date, user_code: username, user_description: user_display, assigned_roles, assigned_branch, assigned_bank, assigned_bank_uid, logintime };
        profile.logintime = logintime;
        profile.dashtime = 1000;
        profile.loggedintoday = 0;
        profile.portal = portal;
        profile.portal_scheme = portal_scheme;
        profile.icon_url = props.parentState.icon_url;
        profile.logo_url = props.parentState.logo_url;




        // send logged in username + token to authorize this socket.id
        // try {
        //   socket.emit('browserlogin', { token, loginid });
        // } catch (err) {
        //   console.log({ SOCK: err })
        // }

        // Since appwrapper is already rendered, its state will not be taken from the cookie. So set it here.
        props.liftWrapperState({ name: "profile" }, profile);
        props.liftGlobalState({ name: "profile" }, profile);

        if (profile.visiting_branches && profile.visiting_branches.length > 0) {
          let { LocalVars } = props.parentState;
          LocalVars.selectedTourBranch = { label: profile.visiting_branches[0].branch_display, value: profile.visiting_branches[0].branch_uid, code: profile.visiting_branches[0].branch_code, more_1: profile.visiting_branches[0].more_1, more_2: profile.visiting_branches[0].more_2 };
          props.liftGlobalState({ name: "LocalVars" }, LocalVars);
        }
        setCookie("profile", JSON.stringify(profile), 1);
        for (var key in orosession) {
          props.liftWrapperState({ name: key }, orosession[key]);
        }

        //eslint-disable-next-line
        history.pushState(null, '', '/dashboard1');
        props.liftGlobalState({ name: "currentPage" }, "dashboard1");

      }
    }




  }
  if (error) {
    window.navigator.vibrate(200);
    setmessage(error);
    // if (error.indexOf('finger') != -1) {
    //   this.setState({ suspecious: true });
    //   setTimeout(() => {
    //     this.setState({ isfaceauth: true })
    //     document.getElementsByClassName("login-btn")[0].click();
    //   }, 5780)
    // }
  }

  if (result.token == "" && result.authenticated == false) {
    props.liftGlobalState(
      { name: "errorMessages" },
      { Login: "Wrong Password" }
    );
  } else {
    setCookie("orosession", JSON.stringify(orosession), 1);
  }
  // Send keystrokes and photo.
}